import dayjs from 'dayjs';

// 指定された年度が開始年度と終了年度の範囲内にあるかを判定する
export const isTargetYearWithinFiscalYearRange = ({
  targetYear,
  startYear,
  endYear,
}: {
  targetYear: number | null | undefined;
  startYear: number | null | undefined;
  endYear: number | null | undefined;
}): boolean => {
  if (typeof targetYear !== 'number') {
    return true;
  }
  if (typeof startYear === 'number' && typeof endYear === 'number') {
    return targetYear >= startYear && targetYear <= endYear;
  }
  if (typeof startYear === 'number') {
    return targetYear >= startYear;
  }
  if (typeof endYear === 'number') {
    return targetYear <= endYear;
  }
  return true;
};

/**
 * 指定された日付から事業年度を計算する
 * 日本の事業年度は4月始まりで、1-3月は前年度として扱う
 * @param date - 計算対象の日付（省略時は現在日時）
 * @returns 事業年度（年）
 * @example
 * calculateProjectFiscalYear(dayjs('2024-04-01')) // => 2024
 * calculateProjectFiscalYear(dayjs('2024-03-31')) // => 2023
 */
export const calculateProjectFiscalYear = (date = dayjs()): number => {
  const year = date.year();
  const month = date.month() + 1;
  if (month <= 3) {
    return year - 1;
  }
  return year;
};
